import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Table, TableHead, TableBody, TableRow, TableCell, Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import routePaths from '../../routePaths';
import i18n from '../../i18n';
import { DateTime } from 'luxon';
import history from '../../history';
import OrderedColumnHeader from './OrderedColumnHeader';
import compose from 'recompose/compose';
import applicationStatuses from './applicationStatuses';

const sortApplications = (applications, order, orderBy) => {
  const orderByProperties = orderBy.split('.');
  const getValue = (element, level) => {
    const el = element[orderByProperties[level]];
    if (level == orderByProperties.length - 1) {
      return el;
    }
    return getValue(el, level + 1, orderByProperties);
  };

  return [...applications].sort((a1, a2) => (getValue(a1, 0) > getValue(a2, 0) ? 1 : -1) * (order === 'asc' ? 1 : -1));
};

const styles = () => ({
  tableRow: {
    cursor: 'pointer',
  },
});

class ParticipantApplications extends React.Component {
  constructor(props) {
    super(props);
    this.state = { orderBy: 'application.createdAt', order: 'desc', applications: [] };
  }

  static getDerivedStateFromProps(props, state) {
    return { applications: sortApplications(props.applications, state.order, state.orderBy) };
  }

  handleChangeSort = orderBy => {
    let newOrder = this.state.orderBy === orderBy
      ? this.state.order === 'asc' ? 'desc' : 'asc'
      : 'asc';

    this.setState({ orderBy, order: newOrder, applications: sortApplications(this.state.applications, newOrder, orderBy) });
  }

  render() {
    const { orderBy, order, applications } = this.state;
    const { classes } = this.props;

    return (
      <React.Fragment>
        <div key="content">
          <Table>
            <TableHead>
              <TableRow>
                <OrderedColumnHeader title={i18n.t('budgetApplications.table.year')} propertyName="budgetYear"
                  orderBy={orderBy} order={order} onChangeSort={this.handleChangeSort} />
                <OrderedColumnHeader title={i18n.t('budgetApplications.table.name')} propertyName="application.title" style={{ width: '100%' }}
                  orderBy={orderBy} order={order} onChangeSort={this.handleChangeSort} />
                <OrderedColumnHeader title={i18n.t('budgetApplications.table.status')} propertyName="application.statusDescription"
                  orderBy={orderBy} order={order} onChangeSort={this.handleChangeSort} />
                {/* <OrderedColumnHeader title={i18n.t('budgetApplications.table.draftUpdatedAt')} propertyName="application.draftUpdatedAt"
                  orderBy={orderBy} order={order} onChangeSort={this.handleChangeSort} /> */}
                <OrderedColumnHeader title={i18n.t('budgetApplications.table.submittedAt')} propertyName="application.submittedAt"
                  orderBy={orderBy} order={order} onChangeSort={this.handleChangeSort} />
              </TableRow>
            </TableHead>
            <TableBody>
              {applications.map(result => (
                <TableRow
                  className={classes.tableRow}
                  hover
                  key={result.application.id}
                  onClick={() => history.push(routePaths.budgetSavedApplication.replace(':id', result.application.id))}
                  style={{ backgroundColor: result.application.status === applicationStatuses.changesRequested.value ? '#FFEBEE' : 'inherit' }}
                >
                  <TableCell>
                    {result.budgetYear}
                  </TableCell>
                  <TableCell>
                    {result.application.title}
                  </TableCell>
                  <TableCell>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      {result.application.statusDescription}
                    </div>
                  </TableCell>
                  {/* <TableCell style={{ whiteSpace: 'nowrap' }}>
                    {result.application.draftUpdatedAt ? DateTime.fromISO(result.application.draftUpdatedAt).toFormat('dd.MM.yyyy HH:mm') : null}
                  </TableCell> */}
                  <TableCell style={{ whiteSpace: 'nowrap' }}>
                    {result.application.createdAt && new Date(result.application.createdAt).getFullYear() > 1 ? DateTime.fromISO(result.application.createdAt).toFormat('dd.MM.yyyy HH:mm') : null}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
          {applications && applications.length === 0 ? <Typography gutterBottom align="center" color="textSecondary" style={{ marginTop: 16 }}>
            {i18n.t('budgetApplications.emptyState')}
            </Typography> : null}
        </div>
      </React.Fragment>
    );
  }
}

ParticipantApplications.propTypes = {
  auth: PropTypes.object,
  account: PropTypes.object,
  applications: PropTypes.array.isRequired,
  classes: PropTypes.object.isRequired,
};

function mapStateToProps(state) {
  return {
    auth: state.budgetAuth,
    account: state.account.data,
  };
}

export default compose(withStyles(styles), connect(mapStateToProps))(ParticipantApplications);



// WEBPACK FOOTER //
// ./src/components/budget/ParticipantApplications.js